import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { CallOutcomeForm } from "./CallOutcomeForm";

export const CallOutcomeSheet = ({ venue, session, onClose, onSaved, onBook, callId, callAction }) => <Sheet open={Boolean(venue)} onOpenChange={(next) => { if (!next) onClose(); }}>
  <SheetContent side="bottom" className="hud-sheet" closeTestId="call-close-button" data-testid="call-sheet">
    <div className="sheet-grab" aria-hidden="true" />
    <SheetHeader><SheetTitle className="sr-only">Esito chiamata</SheetTitle></SheetHeader>
    {venue && <CallOutcomeForm key={`${venue.id}-${callId || "manual"}`} venue={venue} csrfToken={session.csrf_token}
      callId={callId} callAction={callAction} onBack={onClose} onSaved={onSaved} onBook={onBook} />}
  </SheetContent>
</Sheet>;